var map = {
	"./arrow-left.svg": 2600,
	"./arrow-right.svg": 7095,
	"./call.svg": 3927,
	"./clock.svg": 371,
	"./close.svg": 7733,
	"./close2.svg": 8077,
	"./contact.svg": 2301,
	"./email.svg": 2665,
	"./escalator.svg": 8133,
	"./filter.svg": 4969,
	"./info-circle.svg": 3784,
	"./lift.svg": 6651,
	"./location.svg": 2254,
	"./nav/directory-active.svg": 5221,
	"./nav/directory-inactive.svg": 5920,
	"./nav/get-info-active.svg": 3319,
	"./nav/get-info-inactive.svg": 598,
	"./nav/wayfinder-active.svg": 3257,
	"./nav/wayfinder-inactive.svg": 5612,
	"./nav/whatson-active.svg": 5544,
	"./nav/whatson-inactive.svg": 3553,
	"./search.svg": 1599,
	"./stair.svg": 9462,
	"./switch.svg": 2607,
	"./switch1.svg": 7884,
	"./x.svg": 1345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6599;